export const slotNames = {
  mobile: {
    right: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_300x250_Mobile',
      slotSize: [300, 250],
      slotId: 'div-gpt-ad-1647329133785-0',
    },
    top: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_320x50_Mobile_Top',
      slotSize: [320, 50],
      slotId: 'div-gpt-ad-1647329364667-0',
    },
    bottom: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_320x50_Mobile_Bottom',
      slotSize: [320, 50],
      slotId: 'div-gpt-ad-1647329323632-0',
    },
  },
  desktop: {
    right: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_300x250',
      slotSize: [[300, 250], [200, 200], 'fluid', [250, 250]],
      slotId: 'div-gpt-ad-1641304661162-0',
    },
    top: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_728x90_Top',
      slotSize: [[728, 90], 'fluid'],
      slotId: 'div-gpt-ad-1641304769377-0',
    },
    bottom: {
      slotName: '/30398149/SatisOfisi_Adunits/HomePage_728x90_Bottom',
      slotSize: [[728, 90], 'fluid'],
      slotId: 'div-gpt-ad-1641304739909-0',
    },
  },
};

export default slotNames;
